import React from 'react'
import ReactPaginate from 'react-paginate'
import { LeftArrow, RightArrow } from '../assets/svg'
import { _object } from 'utils/interfaces'

const Pagination: React.FC<_object> = ({ pageCount, onPageChange, current_page }) => {
  const handlePageChange = ({ selected }: { selected: number }) => {
    onPageChange({ selected })
  }

  return (
    <ReactPaginate
      previousLabel={<LeftArrow className="pointer-events-none h-3 w-3" />}
      nextLabel={<RightArrow className="pointer-events-none h-3 w-3" />}
      breakLabel="..."
      pageCount={pageCount}
      pageRangeDisplayed={3}
      onPageChange={handlePageChange}
      forcePage={current_page - 1}
      containerClassName="flex space-x-4 justify-center mt-8 pagination"
      pageClassName="text-base w-8 h-8 rounded-md hover:bg-purple-900 hover:text-white font-medium text-black flex items-center justify-center cursor-pointer pointer-events-auto"
      pageLinkClassName="w-full h-full flex items-center justify-center"
      activeClassName="bg-purple-900 text-white"
      activeLinkClassName="w-full h-full flex items-center justify-center"
      previousClassName="w-8 h-8 bg-white rounded-md hover:bg-purple-900 hover:text-white flex items-center justify-center cursor-pointer pointer-events-auto"
      previousLinkClassName="w-full h-full flex items-center justify-center"
      nextClassName="w-8 h-8 bg-white rounded-md hover:bg-purple-900 hover:text-white flex items-center justify-center cursor-pointer pointer-events-auto"
      nextLinkClassName="w-full h-full flex items-center justify-center"
      disabledClassName="opacity-50 cursor-not-allowed"
      disabledLinkClassName="cursor-not-allowed"
      breakClassName="text-2xl"
    />
  )
}

export default Pagination
